import axios from "axios";
import { Item } from "../item.js";
import { trackEvent } from "../utils/trackEvents"; 
import { API_BASE_URL } from "../utils/apiConfig.js";

class CartItem {
    constructor(cartProductId, quantity, cartId, item = "") {
        this.cartProductId = cartProductId;
        this.quantity = quantity;
        this.cartId = cartId;
        this.item = item;
    }
}

/* Maps raw database results into CartItem and Item class instances. */
export async function fetchCartProducts() {
    try {
        const rawId = localStorage.getItem("cartId");

        if (!rawId || rawId === "null" || rawId === "undefined") {
            return [];
        }
        
        const cartId = parseInt(rawId);
        const response = await axios.post(`${API_BASE_URL}/api/cart-products`, { cartId });

        if (!Array.isArray(response.data)) return [];

        return response.data.map((product) => {
            return new CartItem(
                product.cartProductId,
                product.quantity,
                product.cartId,
                new Item(
                    product.productId,
                    product.productName,
                    product.price || 0,
                    product.productImage
                        ? `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/${product.productImage}`
                        : `https://open-access-online-experimental-retail-facility-product-images.s3.us-east-2.amazonaws.com/images/autoFill.jpg`,
                    product.productDescription || "",
                    ""
                )
            );
        });

    } catch (err) {
        console.error("fetchCartProducts Failed:", err);
        return [];
    }
}

/* Updates item quantity or removes an item from the cart. */  
export async function updateItem(quantity, productId, actionId) {
    try {
        const cartId = parseInt(localStorage.getItem("cartId"));
        const sessionId = localStorage.getItem("sessionId");
        const experimentId = localStorage.getItem("experimentId");

        const response = await axios.post(`${API_BASE_URL}/api/update-cart`, { 
            quantity, 
            cartId, 
            productId, 
            actionId 
        });

        if (response.status === 200) {
            if (quantity <= 0) {
                trackEvent(sessionId, 'CLICK', 'Remove Item from Cart', { productId }, experimentId);
            } else {
                trackEvent(sessionId, 'CLICK', 'Update Cart Quantity', { productId, newQty: quantity }, experimentId);
            }

            window.dispatchEvent(new Event("cartUpdated"));
            return true;
        }
    } catch (error) {
        console.error("updateItem Failed:", error.response?.data?.message || error.message);
        return false;
    }
}

/* Adds a product to the cart. */
export async function addToCart(quantity, productId) {
    try {
        if (!productId) return false;

        const sessionId = localStorage.getItem("sessionId");
        const experimentId = localStorage.getItem("experimentId");
        let cartId = localStorage.getItem("cartId");

        // Ensure a cart exists in the DB before adding items
        if (!cartId || cartId === "null") {
            const cartRes = await axios.post(`${API_BASE_URL}/api/cart`, { sessionId });
            cartId = cartRes.data.cartId;
            localStorage.setItem("cartId", cartId); // Save to localStorage
        }

        const response = await axios.post(`${API_BASE_URL}/api/insert-cart`, { 
            cartId, 
            quantity, 
            sessionId, 
            productId 
        });

        if (response.status === 200) {
            window.dispatchEvent(new Event("cartUpdated"));
            return true;
        }
    } catch (error) {
        console.error("addToCart Failed:", error.response?.data || error.message);
        return false;
    }
}

export function removeCart() {
    localStorage.removeItem("cartId");
}

/* Deletes all items from the current cart. */
export async function clearCart() {
    try {
        const cartId = parseInt(localStorage.getItem("cartId"));
        const sessionId = localStorage.getItem("sessionId");
        const experimentId = localStorage.getItem("experimentId");

        const response = await axios.post(`${API_BASE_URL}/api/clear-cart`, { cartId });
        
        if (response.status === 200) {
            trackEvent(sessionId, 'CLICK', 'Clear Entire Cart', {}, experimentId);
            window.dispatchEvent(new Event("cartUpdated"));
            return true;
        }
    } catch (error) {
        console.error("clearCart Failed:", error);
        return false;
    }
}